// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2OIJc","title":"BackImages_title__1l4Su","images":"BackImages_images__ZiCvg"};